import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '../src/styles/color_theme.css'
import '../src/styles/custom.css'
import '../src/styles/custom.scss'
import '../src/styles/demo-6.css'
import '../src/styles/demo-7.css'
import '../src/styles/skin_color.css'
import '../src/styles/style_rtl.css'
import '../src/styles/style.css'
import '../src/styles/vendors_css.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from "./store";
import { Provider } from "react-redux";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Provider store={store}>
    <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
